$(document).ready(function(){
    var submitForm = false;

    function mcs_pass_inputs_disabled() {
        $('#customPassEmail').prop({'disabled' : true});
        $('#customPass').prop({'disabled' : true});
        $('#customPassSubmit').prop({'disabled' : true});
    }

    function mcs_pass_inputs_enabled() {
        $('#customPassEmail').prop({'disabled' : false});
        $('#customPass').prop({'disabled' : false});
        $('#customPassSubmit').prop({'disabled' : false});
    }

    function mcs_pass_error(errorMessage) {
        var error = $('#customPassError');

        if( error.length > 0 ) {
            error.html(errorMessage);
            error.removeClass('d-none');
        } else {
            error.html('');
            error.addClass('d-none');
        }
    }

    function mcs_pass_success(url) {
        var error = $('#customPassError');

        error.removeClass('d-none');
        error.removeClass('text-red');
        error.addClass('text-green');

        error.html('Password successful!<br />If you don\'t automatically redirect in 3 seconds, please <a class="text-green" href="'+url+'">click here<a/>.');
    }

    $('#customPassForm').submit(function(e){
        if( submitForm === false ) {
            e.preventDefault();
            // console.log(e.target.action);
            // return;

            mcs_pass_inputs_disabled();
            mcs_pass_error('');

            var formAction = e.target.action;
            var email = $('#customPassEmail').val();
            var pass_user = $('#customPass').val();

            if( email.length == 0 ) {
                mcs_pass_error('Please enter an email address.');
                mcs_pass_inputs_enabled();
                return;
            }

            if( pass_user.length == 0 ) {
                mcs_pass_error('Please enter a password.');
                mcs_pass_inputs_enabled();
                return;
            }

            var data = {
                'action': 'mcs_check_password',
                'page_id': ajax_object.pass_dest,
                'email' : email,
                'password' : pass_user
            };

            $.ajax({
                url : ajax_object.ajaxurl,
                data: data,
                type: 'POST',
                success:function(data){
                    var response = $.parseJSON(data);

                    if( response && response.response.length > 0 && !response.error.length ) {
                        mcs_pass_success(formAction);
                        // submitForm = true;

                        setTimeout(function(){
                            // mcs_pass_inputs_enabled();
                            // $('#customPassForm').unbind('submit').submit();
                            window.location.href = formAction;
                        }, 1000);
                        // return;
                    } else if( response.error.length > 0) {
                        mcs_pass_error(response.error);
                        mcs_pass_inputs_enabled();
                    } else {
                        mcs_pass_error('Unknown Error. Please try again or contact website administrator.');
                        mcs_pass_inputs_enabled();
                    }
                },
                error:function(data){
                    mcs_pass_error('Error ' + data.status + '. <br />' + data.statusText + '<br />Please try again.');
                    mcs_pass_inputs_enabled();
                }
            });
        }
    })
})
